import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton } from "@material-ui/core";
import { useIsDesktop } from "../../../../../Hooks";

// Styles
import useStyles from "./styles";

function TableActions({ anchorPosition, actions }) {
  const { isDesktop } = useIsDesktop();

  const styles = useStyles({ isDesktop });

  return (
    <Box
      className={styles.actionsContainer}
      style={{
        top: anchorPosition?.y || 0, // Fallback to 0 if no anchorPosition
      }}
    >
      <Box className={styles.flex}>
        {actions.map(({ Icon, actionHandler }) => (
          <IconButton className={styles.button} onClick={() => actionHandler()}>
            <Icon />
          </IconButton>
        ))}
      </Box>
    </Box>
  );
}

TableActions.propTypes = {
  anchorPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  actions: PropTypes.array,
};

TableActions.defaultProps = {
  anchorPosition: { x: 0, y: 0 },
  actions: [],
};

export default TableActions;
